var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"no-menu":"","folded":false,"no-title":"","hfull":""}},[(!_vm.binding)?_c('user-form',{attrs:{"user-id":_vm.$route.params.id,"full":""},on:{"updateUser":_vm.updateUser}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }